import { css, StyleSheet } from 'aphrodite';
import { FC } from 'react';
import { Avatar2, AvatarProps } from '../../../../components/Avatar2';
import { alizarinCrimson } from '../../../../styles/colors';

interface VisibilityIndicatorAvatarProps extends Omit<AvatarProps, 'styleDeclaration'> {
	visible: boolean;
	size?: 'large' | 'small';
}

export const VisibilityIndicatorAvatar: FC<VisibilityIndicatorAvatarProps> = ({
	size,
	visible = true,
	imgSrc,
	fallbackText,
	...rest
}) => {
	return (
		<div className={css(styleSheet.container, styleSheet[size])}>
			<Avatar2
				imgSrc={imgSrc}
				fallbackText={fallbackText}
				styleDeclaration={[styleSheet[size], visible ? null : styleSheet.restricted]}
				{...rest}
			/>
		</div>
	);
};

export const styleSheet = StyleSheet.create({
	container: {
		whiteSpace: 'nowrap',
		position: 'relative',
	},
	restricted: {
		boxShadow: `0 0 0 2px ${alizarinCrimson}`,
	},
	large: {
		height: 50,
		width: 50,
	},
	small: {
		height: 32,
		width: 32,
	},
});
